import {
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  CLEAR_STATE,
} from "../Action/register";

const initialState = {
  registerSuccess: "",
  registerFail: "",
};

function accountReducer(state = initialState, action) {
  switch (action.type) {
    case REGISTER_SUCCESS: {
      return { ...state, registerSuccess: "User Register Successfull" };
    }
    case REGISTER_FAIL: {
      return { ...state, registerFail: action.payload };
    }
    case CLEAR_STATE: {
      return {
        ...state,
        registerSuccess: "",
        registerFail: "",
      };
    }
    default:
      return state;
  }
}

export default accountReducer;
